import type { ServiceContainer } from '@breath-lab/services';
import { WebAnalyticsService } from './WebAnalyticsService';
import { WebAudioService } from './WebAudioService';
import { WebAuthService } from './WebAuthService';
import { WebDataService } from './WebDataService';
import { WebMessagingService } from './WebMessagingService';
import { WebPurchaseService } from './WebPurchaseService';
import { WebRemoteConfigService } from './WebRemoteConfigService';
import { WebStorageService } from './WebStorageService';
import { WebUserDataService } from './WebUserDataService';
import { WebUserMapper } from './WebUserMapper';
import { WebFunctionsService } from './WebFunctionsService';
import { WebCrashlyticsService } from './WebCrashlyticsService';

/**
 * Builds the platform-specific service container for the web app.
 * All slots are real implementations; the services-extraction phase is complete.
 */
export function buildServiceContainer(): ServiceContainer {
  return {
    analytics: new WebAnalyticsService(),
    crashlytics: new WebCrashlyticsService(),
    audio: new WebAudioService(),
    auth: new WebAuthService(),
    data: new WebDataService(),
    messaging: new WebMessagingService(),
    purchases: new WebPurchaseService(),
    remoteConfig: new WebRemoteConfigService(),
    storage: new WebStorageService(),
    sessionStorage: new WebStorageService(sessionStorage),
    userData: new WebUserDataService(),
    userMapper: new WebUserMapper(),
    functions: new WebFunctionsService(),
  };
}
